import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function FeaturedCategories() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            视频分类导航
          </h2>
          <p className="text-sm text-secondary-500 max-w-lg mx-auto">
            八大精选分类，覆盖娱乐、学习、生活等热门领域，助你快速找到感兴趣的视频内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-3 ${
                cat.color === 'primary' ? 'bg-primary-100 text-primary-600' :
                cat.color === 'accent' ? 'bg-accent-100 text-accent-700' :
                'bg-secondary-100 text-secondary-600'
              } group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-secondary-500 text-center leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}